import React, { useEffect, useState } from 'react';
import {
  Dialog, DialogTitle, DialogContent, DialogActions, Button, Box,
  Typography, FormControlLabel, Checkbox, Link, CircularProgress
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import { api } from '../api';

// Запасна версія, якщо правила майстра ще не завантажились.
export const TERMS_VERSION = 'v1';

// Рендер правил як звичайного тексту зі збереженням переносів рядків.
export function TermsContent({ text }) {
  if (!text) {
    return (
      <Box sx={{ textAlign: 'center', py: 3 }}><CircularProgress size={24} /></Box>
    );
  }
  return (
    <Typography
      variant="body2"
      component="pre"
      sx={{ whiteSpace: 'pre-wrap', wordBreak: 'break-word', fontFamily: 'inherit', m: 0 }}
    >
      {text}
    </Typography>
  );
}

export function TermsDialog({ open, onClose, text }) {
  const { t } = useTranslation();
  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth scroll="paper">
      <DialogTitle>{t('terms.dialogTitle')}</DialogTitle>
      <DialogContent dividers><TermsContent text={text} /></DialogContent>
      <DialogActions><Button onClick={onClose}>{t('common.close')}</Button></DialogActions>
    </Dialog>
  );
}

// Чекбокс прийняття правил. Тягне правила майстра (masterId) і віддає {text,version}
// нагору через onTerms — щоб батько зберіг версію, яку прийняв клієнт.
export function TermsAcceptField({ checked, onChange, masterId, onTerms }) {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  const [terms, setTerms] = useState(null); // { text, version, isDefault }

  useEffect(() => {
    if (!masterId) return;
    let alive = true;
    api.getBookingTerms(masterId)
      .then((data) => { if (alive) { setTerms(data); onTerms?.(data); } })
      .catch(() => {});
    return () => { alive = false; };
    // onTerms навмисно не в deps — це стабільний сеттер
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [masterId]);

  return (
    <>
      <FormControlLabel
        control={<Checkbox checked={checked} onChange={(e) => onChange(e.target.checked)} />}
        label={
          <Typography variant="body2">
            {t('terms.acceptPrefix')}{' '}
            <Link component="button" type="button" onClick={(e) => { e.preventDefault(); setOpen(true); }}>
              {t('terms.linkText')}
            </Link>
          </Typography>
        }
      />
      <TermsDialog open={open} onClose={() => setOpen(false)} text={terms?.text} />
    </>
  );
}
